export const enum RequestStatus {
    LOADING,
    SUCCESS,
    ERROR,
    INITIAL,
}